export const createOptions = ({
  min,
  max,
  options,
}: {
  min?: number;
  max?: number;
  options?: { label: string; value: string }[];
}) => {
  return typeof min === 'number' && typeof max === 'number'
    ? Array.from({ length: max - min + 1 }, (_, i) => (min ?? 0) + i).map((value) => ({
        label: value.toString(),
        value: value.toString(),
      }))
    : options;
};
